export default __webpack_public_path__ + "781ac9aab69b769d444b9cb1f7664c5e.svg";